/**
 * @file: useOrgMemberPicker.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { OrgMember } from '@euler/model/entity';
import { usePersistFn } from '@euler/utils/hooks';
import { useCallback, useState } from 'react';

export const useOrgMemberPicker = (options: {
  currentMemberId?: number;
  onChange: (user: OrgMember) => void;
}) => {
  const [isUserPickerVisible, setIsUserPickerVisible] = useState(false);

  const onUserPickerPress = useCallback(() => {
    setIsUserPickerVisible(true);
  }, []);

  const onUserPickerDismiss = usePersistFn(() => {
    setIsUserPickerVisible(false);
  });

  const onUserSelected = usePersistFn((tech: OrgMember) => {
    setIsUserPickerVisible(false);
    if (tech.id !== options?.currentMemberId) {
      options.onChange(tech);
    }
  });

  return {
    isUserPickerVisible,
    onUserPickerPress,
    onUserPickerDismiss,
    onUserSelected,
  };
};
